import config from '../../config/config';

export const CREATE_APPLICATION = 'CREATE_APPLICATION';
export const CREATE_APPLICATION_SUCCESS = 'CREATE_APPLICATION_SUCCESS';
export const CREATE_APPLICATION_FAILURE = 'CREATE_APPLICATION_FAILURE';
export const RESET_CREATE_APPLICATION = 'RESET_CREATE_APPLICATION';

export function createApplication(formData) {
    return {
        failureActionTypeOrCreator: createApplicationFailure,
        fetchParams: {
            method: 'POST',
            url: `${config.underwritingApiUrl}/onboarding/createApplication`,
            body: formData,
            shouldStringifyBody: false
        },
        loadActionTypeOrCreator: CREATE_APPLICATION,
        successActionTypeOrCreator: createApplicationSuccess
    };
}

export function createApplicationSuccess(response) {
    return {
        type: CREATE_APPLICATION_SUCCESS,
        response: response
    };
}

export function createApplicationFailure(error) {
    return {
        error,
        type: CREATE_APPLICATION_FAILURE
    };
}

export function resetCreateApplication() {
    return {
        type: RESET_CREATE_APPLICATION
    };
}
